import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const flagInboundMissingReturn = {
  name: "flagInboundMissingReturn" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({ changed: z.boolean() }),
};
